"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Hotkey = _interopRequireDefault(require("../Hotkey"));

require("./modal.sass");

var _ref = _react.default.createElement("div", {
  className: "blackout"
});

var Modal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Modal, _PureComponent);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      targetMouseDown: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleRef", function (element) {
      return _this.element = element;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleOnOutsideMouseDown", function (e) {
      _this.setState({
        targetMouseDown: e.target
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleOnOutsideMouseUp", function (e) {
      var preventCloseOnOutsideClick = _this.props.preventCloseOnOutsideClick;

      if (e.target.contains(_this.element) && e.target.isSameNode(_this.state.targetMouseDown) && !preventCloseOnOutsideClick) {
        _this.close(e);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "close", function (e) {
      return _this.props.onClose && _this.props.onClose(e);
    });
    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          preventCloseOnEsc = _this$props.preventCloseOnEsc;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('modal', className),
        onMouseDown: this.handleOnOutsideMouseDown,
        onMouseUp: this.handleOnOutsideMouseUp
      }, _ref, !preventCloseOnEsc && _react.default.createElement(_Hotkey.default, {
        shortcut: "esc",
        action: this.close
      }), _react.default.createElement("div", {
        className: "modal-scroll"
      }, _react.default.createElement("div", {
        className: "modal-content",
        ref: this.handleRef
      }, children)));
    }
  }]);
  return Modal;
}(_react.PureComponent);

exports.default = Modal;
(0, _defineProperty2.default)(Modal, "defaultProps", {
  preventCloseOnOutsideClick: false,
  preventCloseOnEsc: false
});
Modal.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.string,
  onClose: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  preventCloseOnOutsideClick: _propTypes.default.bool
} : {};